module.exports = __webpack_public_path__ + "images/sayer_tindall.jpg?v=93cf23f6b6a65b22c611096e110da734";